// extracted by mini-css-extract-plugin
export default {"content":"RpivluDefmXRoPAugeuJ","delete-package":"MZBZW1xO3fqLGeXxQNOs"};